import { execAdmin } from '@src/apis/reware/utils';

import type { FacetGroup, FetchFacetsExecVariables, FetchFacetsExecResponse } from './types';

export interface FetchFacetsArgs {
  partnerId: number;
}

/**
 * Fetches facets for a partner using the shopFacets query.
 * Returns an array of FacetGroup objects with tag and values.
 */
export const fetchFacets = async ({ partnerId }: FetchFacetsArgs): Promise<FacetGroup[]> => {
  const query = `
    query getFacets($partnerId: Int!) {
      partner(id: $partnerId) {
        shopFacets {
          tag
          values {
            name
          }
        }
      }
    }
  `;

  const data = await execAdmin<FetchFacetsExecVariables, FetchFacetsExecResponse>(
    query,
    { variables: { partnerId } }
  );

  // Transform to FacetGroup format with id
  return (data.partner.shopFacets ?? [])
    .filter((fg): fg is NonNullable<typeof fg> => fg != null)
    .map((fg) => ({
      id: fg.tag ?? '',
      tag: fg.tag ?? '',
      values: (fg.values ?? [])
        .filter((v): v is NonNullable<typeof v> => v != null)
        .map((v) => ({ name: v.name ?? '', count: 0 })),
    }));
};
